export const getFirstAttributeValue = (attributes, keys, fallback = '') => {
    const source = attributes && typeof attributes === 'object' ? attributes : {};
    const keyList = Array.isArray(keys) ? keys : [keys];

    for (const key of keyList) {
        if (!key || !(key in source)) {
            continue;
        }

        const value = source[key];
        if (Array.isArray(value)) {
            const firstValue = value.find((candidate) => candidate !== null && candidate !== undefined);
            const normalizedArrayValue = String(firstValue ?? '').trim();
            if (normalizedArrayValue) {
                return normalizedArrayValue;
            }
            continue;
        }

        const normalizedValue = String(value ?? '').trim();
        if (normalizedValue) {
            return normalizedValue;
        }
    }

    return fallback;
};

export const getUserAttributeValue = (user, keys, fallback = '') =>
    getFirstAttributeValue(user?.attributes, keys, fallback);
